import * as React from "react";
import { useState } from "react";
import Dialog from "@mui/material/Dialog";
import CheckIcon from "@mui/icons-material/Check";
import login_img from "../../assets/profile/login_img.png";
import login_bottom from "../../assets/profile/login_bottom.png";
import close_icon from "../../assets/profile/close_icon.png"
export default function LoginDialog({ open, handleClose }) {
  const [phone, setPhone] = useState("");
  const [phoneError, setPhoneError] = useState(false);
  const [showOtp, setShowOtp] = useState(false);
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [timer, setTimer] = useState(30);
  const [canResend, setCanResend] = useState(false);
  const [loginSuccess, setLoginSuccess] = useState(false);
  const [otpError, setOtpError] = useState("");
  const phoneRef = React.useRef(null);
  const handleGetOtp = (e) => {
    if (e) e.preventDefault();
    const isValidPhone = /^[6-9][0-9]{9}$/.test(phone);
    if (!isValidPhone) {
      setPhoneError(true);
      return;
    }
    setPhoneError(false);
    setShowOtp(true);
  };
  React.useEffect(() => {
    if (!showOtp) {
      phoneRef.current?.focus();
    }
  }, [showOtp]);
  const handleOtpChange = (value, index) => {
    if (!/^\d?$/.test(value)) return;
    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);
    setOtpError("");
    if (value && index < 5) {
      document.getElementById(`otp-${index + 1}`)?.focus();
    }
  };
  const handleOtpKeyDown = (e, index) => {
    if (e.key === "Backspace") {
      e.preventDefault();
      const newOtp = [...otp];
      if (newOtp[index]) {
        newOtp[index] = "";
        setOtp(newOtp);
      } else if (index > 0) {
        newOtp[index - 1] = "";
        setOtp(newOtp);
        document.getElementById(`otp-${index - 1}`)?.focus();
      }
    }
  };
  React.useEffect(() => {
    if (!showOtp) return;
    setCanResend(false);
    setTimer(30);
    const interval = setInterval(() => {
      setTimer((prev) => {
        if (prev === 1) {
          clearInterval(interval);
          setCanResend(true);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    setTimeout(() => {
      document.getElementById("otp-0")?.focus();
    }, 0);
    return () => clearInterval(interval);
  }, [showOtp]);

  const handleResendOtp = () => {
    if (!canResend) return;
    setOtp(["", "", "", "", "", ""]);
    setOtpError("");
    setTimeout(() => {
      document.getElementById("otp-0")?.focus();
    }, 0);
    setTimer(30);
    setCanResend(false);
  };
  const handleVerifyOtp = (e) => {
    if (e) e.preventDefault();
    const enteredOtp = otp.join("");
    if (enteredOtp.length !== 6) {
      setOtpError("Please enter the complete 6-digit OTP");
      return;
    }
    setOtpError("");
    setLoginSuccess(true);
  };
  const handleDialogClose = () => {
    // Reset all state on close
    setPhone("");
    setPhoneError(false);
    setShowOtp(false);
    setOtp(["", "", "", "", "", ""]);
    setTimer(30);
    setCanResend(false);
    setLoginSuccess(false);
    setOtpError("");
    handleClose();
  };
  return (
    <Dialog
      PaperProps={{
        sx: {
          maxWidth: "1052px",
          borderRadius: "0px",
        },
      }}
      open={open}
      onClose={handleDialogClose}
    >
      <div>
        <div className="grid md:grid-cols-2 grid-cols-1 md:gap-4 w-full">
          {/* Left image */}
          <div>
            <img src={login_img} className="object-cover" alt="" />
          </div>
          {/* Right content */}
          <div className="flex flex-col lg:p-6 w-full lg:gap-5 relative md:p-3 p-4 gap-4 md:gap-2 justify-center xl:p-12 xl:gap-6 me-4">
            <button onClick={handleDialogClose} className="top-4 right-3 absolute">
              <img src={close_icon} alt="" />
            </button>            
            {/* ✅ Success screen */}
            {loginSuccess ? (
              <div className="flex flex-col items-center gap-4 sm:py-6 py-8">
                <div className="bg-[#2a552f] rounded-full p-4">
                  <CheckIcon style={{ color: "#f4e390", fontSize: 40 }} />
                </div>
                <h2 className="lg:text-2xl text-xl font-lexend font-semibold text-[#2a552f]">
                  Login Successful!
                </h2>
                <p className="text-sm text-gray-500 text-center">
                  Welcome back! You are now logged in.
                </p>
                <button
                  onClick={handleDialogClose}
                  className="bg-[#2a552f] text-[#f4e390] text-base font-lexend py-2 px-8 rounded-lg mt-2"
                >
                  Continue
                </button>
              </div>
            ) : showOtp ? (
              /* ✅ OTP screen */
              <form onSubmit={handleVerifyOtp} className="flex flex-col md:gap-4 gap-2">
                <div>
                   <h2 className="lg:text-[26px] text-xl font-lexend font-semibold">
                    Login/Signup
                  </h2>
                  <p className="lg:text-base text-sm font-lexend font-light mt-8">
                   Please enter the 6 digit OTP here
                  </p>
                </div>
                {/* OTP boxes */}
                <div className="flex gap-4  mt-2">
                  {otp.map((digit, index) => (
                    <input
                      key={index}
                      id={`otp-${index}`}
                      type="text"
                      inputMode="numeric"
                      maxLength={1}
                      value={digit}
                      onChange={(e) => handleOtpChange(e.target.value, index)}
                      onKeyDown={(e) => handleOtpKeyDown(e, index)}
                      className={`lg:w-14 lg:h-12 w-10 placeholder:font-lexend font-lexend h-10 xs:w-8 xs:h-8 xxs:w-6 xxs:h-6 xxs:text-sm text-center xs:text-base text-lg font-semibold border rounded-lg outline-none focus:border-[#2a552f] transition-colors ${
                        otpError ? "border-red-500" : "border-[#b1b1b1]"
                      }`}
                    />
                  ))}
                </div>
                {/* OTP error */}
                {otpError && (
                  <p className="text-red-500 text-xs -mt-2">{otpError}</p>
                )}
                <div className="flex justify-between sm:flex-col flex-row sm:items-start sm:gap-2  items-center">
                  <div className="">
                    <p className="text-base font-lexend font-light">
                      Resed OTP in {timer} Seconds
                    </p>
                    <button
                      type="button"
                      onClick={handleResendOtp}
                      className={`text-[#b3d2b1] font-medium font-lexend ${canResend ? "cursor-pointer" : "cursor-not-allowed"} `}
                    >
                      Resend OTP?
                    </button>
                  </div>
                  
                  <div className="flex gap-3">
                    <button
                      type="submit"
                      className="bg-[#2a552f] text-[#f4e390] text-base font-lexend py-2.5 px-3 lg:px-6 rounded-lg"
                    >
                      Verify OTP
                    </button>
                  </div>
                </div>

                <p className="text-sm lg:mt-8 mt-4 font-lexend sm:mt-2 text-[#a2a19f]">
                  By continuing, I agree to{" "}
                  <span className="text-[#2a552f] font-semibold">
                    Moondew's Terms & Conditions & Privacy Policy
                  </span>
                </p>
              </form>
            ) : (
              /* ✅ Phone screen */
              <form onSubmit={handleGetOtp} className="flex flex-col lg:gap-4 sm:gap-2">
                <div>
                  <h2 className="lg:text-[26px] text-xl font-lexend font-semibold">
                    Login/Signup
                  </h2>
                  <p className="lg:text-base text-sm font-lexend font-light mt-1">
                    Enter your phone number <br />
                    we will send you a 6 digit OTP.
                  </p>
                </div>

                <div>
                  <div className=" border border-[#b1b1b1] rounded-[10px] px-3 mt-2 focus-within:border-[#2a552f]">
                    <input
                      ref={phoneRef}
                      type="tel"
                      name="phone"
                      placeholder="Phone *"
                      value={phone}
                      maxLength={10}
                      onChange={(e) => {
                        setPhone(e.target.value.replace(/\D/g, ""));
                        setPhoneError(false);
                      }}
                      className="lg:w-full w-60 placeholder:font-lexend font-lexend lg:py-3 py-2 outline-none bg-transparent text-base"
                    />
                  </div>
                  {phoneError && (
                    <p className="text-red-500 text-xs mt-1">
                      Please enter a valid 10-digit mobile number.
                    </p>
                  )}
                </div>

                <div className="flex justify-end">
                  <button
                    type="submit"
                    className="bg-[#2a552f] text-[#f4e390] lg:text-xl text-base font-lexend py-2.5 px-6 rounded-lg"
                  >
                    Get OTP
                  </button>
                </div>

                <p className="text-sm lg:mt-8 mt-2 font-lexend text-[#a2a19f]">
                  By continuing, I agree to{" "}
                  <span className="text-[#2a552f] font-semibold">
                    Moondew's Terms & Conditions & Privacy Policy
                  </span>
                </p>
              </form>
            )}
          </div>
        </div>
        <img src={login_bottom} alt="" className="w-full" />
      </div>
    </Dialog>
  );
}
